import { render, staticRenderFns } from "./custom_pcb_ban_new.vue?vue&type=template&id=510ed10c&scoped=true"
import script from "./custom_pcb_ban_new.vue?vue&type=script&lang=js"
export * from "./custom_pcb_ban_new.vue?vue&type=script&lang=js"
import style0 from "./custom_pcb_ban_new.vue?vue&type=style&index=0&id=510ed10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ed10c",
  null
  
)

export default component.exports